'use client';
import React from 'react';
import { Input, Form } from 'antd';
import { useTranslations } from 'next-intl';
import ErrorAlert from '@/ui/features/authentication/components/errorAlert';
import InputForm from '@/ui/shared/components/inputForm';
import { useController } from './Controller';
import Image from 'next/image';
import AfiwaButton from '@/ui/shared/components/afiwaButton';
import { Link } from '@/intl/navigation';
import appRoutes from '@/constants/routes';

function SignInForm() {
  const { loading, apiError, handleLogin } = useController();
  const auth = useTranslations('auth');

  const onSubmit = (values: { email: string; password: string }) => {
    handleLogin(values);
  };

  return (
    <Form
      autoComplete="off"
      layout="vertical"
      onFinish={onSubmit}
      requiredMark={false}
    >
      {/* FORM-ERRORS */}
      <ErrorAlert errorType={apiError} />

      {/* EMAILE */}
      <InputForm
        label={auth('forms.labels.email')}
        name="email"
        placeholder={auth('forms.placeholders.sampleMail')}
        rules={[{ type: 'email', message: auth('forms.errors.invalidMail') }]}
        component={
          <Input
            required
            // className="custom-input"

            placeholder={auth('forms.placeholders.sampleMail')}
            size="large"
            prefix={
              <Image
                src={'/icons/enveloppe.svg'}
                alt="enveloppe-icon"
                height={16}
                width={16}
                className="mr-2"
              />
            }
            onInput={(e) =>
              (e.currentTarget.value =
                e.currentTarget.value.toLocaleLowerCase())
            }
          />
        }
      />

      {/* PASSWORD */}
      <InputForm
        label={auth('forms.labels.password')}
        name="password"
        rules={[{ required: true, message: auth('forms.errors.fillPassword') }]}
        component={
          <div className="flex flex-col space-y-1 md:space-y-2">
            <Input.Password
              // className="custom-input"
              placeholder={auth('forms.placeholders.password')}
              size="large"
              prefix={
                <Image
                  src={'/icons/lock.svg'}
                  alt="lock-icon"
                  height={16}
                  width={16}
                  className="mr-2"
                />
              }
            />
            <p className={`ml-auto flex  flex-row sm:text-xs lg:text-xs`}>
              <span className="mr-2  font-bold text-gray-900">
                {auth('forgotPassword')}
              </span>

              <Link
                href={appRoutes.resetPassword}
                className={`font-semibold text-secondary underline
                   hover:text-secondary-dark`}
              >
                {auth('resetPassword')}
              </Link>
            </p>
          </div>
        }
      />

      <AfiwaButton
        type={'primary'}
        htmlType="submit"
        loading={loading}
        text={auth('login')}
        className={'mt-6 flex w-full justify-center'}
      />
    </Form>
  );
}

export default SignInForm;
